import {
  ExtendedSalaryComponent,
  StatutoryCompliances
} from '../employee-salary/employee-salary.state'
import { User } from '../user/user.state'

export enum PayOutMode {
  CREATE = 'create',
  REVISE = 'revise',
  UPDATE = 'update'
}

export interface CTCData {
  payoutFrequency: PayoutFrequency
  basis: Basis
  currency: string
  ctc: number
  effectiveFrom: string
  payoutFrom: string
}

export interface PayoutData {
  basic: number
  pf: number
  otherComponents: ExtendedSalaryComponent[] | []
  specialAllowance: number
}

export enum PayoutFrequency {
  ANNUALLY = 'annually',
  SEMI_ANNUALLY = 'semi_annually',
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  BI_WEEKLY = 'bi_weekly',
  WEEKLY = 'weekly',
  DAILY = 'daily'
}

export enum Basis {
  MONTHLY = 'monthly',
  BI_WEEKLY = 'bi_weekly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
  HOURLY = 'hourly'
}

export interface PayoutAgreement {
  belongsTo: string | null
  employeeId: string | null
  payoutFrequency: PayoutFrequency | null
  statutoryCompliances: StatutoryCompliances | null
  basis: Basis | null
  ctc: number | null
  currency: string | null
  effectiveFrom: string | null
  payoutFrom: string | null
  payoutData: PayoutData | null
}

export interface IncomingPayoutAgreement extends PayoutAgreement {
  id: string
  employee?: User
  createdAt: string
  updatedAt: string
  deletedAt: string
}

export interface PayoutAgreementWithUser extends PayoutAgreement {
  id: string
  employee: User
}

export interface PayoutAgreementState {
  payout: PayoutAgreement | null
  revisedPayout: PayoutAgreement | null
  allPayouts: PayoutAgreement[] | null
  allPayoutsByBusiness: PayoutAgreementWithUser[] | null
  loading: boolean
  error: string | null
}

export const initialState: PayoutAgreementState = {
  payout: null,
  revisedPayout: null,
  allPayouts: null,
  allPayoutsByBusiness: null,
  loading: false,
  error: null
}
